import Types from "../action/types"

export function theme(
  state = { primaryColor: "#002b5b", secondaryColor: "#2b4865",cardColor:"#002b5b",highlightBorderColor:"#ffcf86",
  primaryButtonColor:"#fb0e56" },
  action = {}
) {
  switch (action.type) {
    case Types.SET_THEME:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducer/theme.js